import {
  EntrancePlantDetailDTO,
  EntrancePlantInfoCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import EntrancePlantStructure from './EntrancePlantStructure/EntrancePlantStructure.vue';
import DeviceLanguageTab from './DeviceLanguageTab/DeviceLanguageTab.vue';
import CallModeTab from './CallModeTab/CallModeTab.vue';
import AccessCodeTab from './AccessCodeTab/AccessCodeTab.vue';

enum ParametersTab {
  structure = 'structure',
  devLanguage = 'devLanguage',
  callmode = 'callMode',
  accessCode = 'accessCode',
  // submitIssue = 'submitIssue',
}

@Options({
  name: 'EntrancePlantSettings',
  computed: {
    ...mapState(['currentEntrancePlant', 'adminView']),
  },
  components: {
    EntrancePlantStructure,
    DeviceLanguageTab,
    CallModeTab,
    AccessCodeTab,
    // SubmitIssueTab
  },
  emits: ['update-list'],
})
export default class EntrancePlantSettings extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  adminView!: boolean;
  tabSelected: ParametersTab = ParametersTab.structure;
  tabContent = 'EntrancePlantStructure';
  infoPlant: EntrancePlantInfoCreateDTO = new EntrancePlantInfoCreateDTO();

  async mounted() {
    this.tabContent = this.adminView
      ? 'DeviceLanguageTab'
      : 'EntrancePlantStructure';
    this.initializeData();
  }

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  initializeData() {
    this.infoPlant = new EntrancePlantInfoCreateDTO({
      language: this.currentEntrancePlant.language,
      addressBookSorting: this.currentEntrancePlant.addressBookSorting,
      addressingType: this.currentEntrancePlant.addressingType,
      denominationApartments: this.currentEntrancePlant.denominationApartments,
      denominationBuildings: this.currentEntrancePlant.denominationBuildings,
      denominationFloors: this.currentEntrancePlant.denominationFloors,
      denominationRisers: this.currentEntrancePlant.denominationRisers,
      callingCodeShowAddressBook: this.currentEntrancePlant.callingCodeShowAddressBook,
      keypadCodePasspartoutMode: this.currentEntrancePlant.keypadCodePasspartoutMode,
      keypadCodePasspartoutCode: this.currentEntrancePlant.keypadCodePasspartoutCode,
      keypadCodeRequiredLength: this.currentEntrancePlant.keypadCodeRequiredLength
    });
  }

  handleTabClick(event: { index: number }) {
    let tab: ParametersTab = ParametersTab.structure;
    switch (event.index) {
      case 0:
        tab = ParametersTab.structure;
        this.tabContent = 'EntrancePlantStructure';
        break;
      case 1:
        tab = ParametersTab.devLanguage;
        this.tabContent = 'DeviceLanguageTab';
        break;
      case 2:
        tab = ParametersTab.callmode;
        this.tabContent = 'CallModeTab';
        break;
      case 3:
        tab = ParametersTab.accessCode;
        this.tabContent = 'AccessCodeTab';
        break;
      // case 4:
      //   tab = ParametersTab.submitIssue;
      //   this.tabContent = 'SubmitIssueTab';
      //   break;
    }
  }

  handleUpdateList() {
    this.$emit('update-list');
  }
}
